module.exports = __webpack_public_path__ + "img/sm.7f0fe9f.svg";